export enum BulkActionStatus {
  SCHEDULED = 'SCHEDULED',
  PROCESSING = 'PROCESSING',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
}

export enum BulkActionType {
  CONTACT_COMPANY_IMPORT = 'CONTACT_COMPANY_IMPORT',
  O365_MAIL_HISTORY_IMPORT = 'O365_MAIL_HISTORY_IMPORT',
  O365_EVENT_HISTORY_IMPORT = 'O365_EVENT_HISTORY_IMPORT',
  COMPANY_UPDATE = 'COMPANY_UPDATE',
  CONTACT_UPDATE = 'CONTACT_UPDATE',
}
